export let marchUppercase = "Td6EJ";
export default {marchUppercase};